import { ShopOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import { type FormItemProps } from '../../FormItem';
import { type SelectFieldProps } from '../../SelectField';
import { type TranslationDrawerProps, useTranslationDrawer } from '../../TranslatedInputField/TranslationDrawer';
import { useTranslationMultipleEntryDrawer } from '../../TranslatedInputFieldArray/TranslationDrawer';
import {
    type DealershipPriceDisclaimerDrawerProps,
    useDealershipPriceDisclaimerDrawer,
} from './DealershipPriceDisclaimerDrawer';
import { useDealershipPriceDisclaimerMultipleEntryDrawer } from './DealershipPriceDisclaimerMultipleEntryDrawer';

export type DisclaimerKind = 'priceDisclaimer' | 'financingDisclaimer' | 'insuranceDisclaimer';
export type DealershipPriceDisclaimerFieldProps = Pick<
    SelectFieldProps,
    'options' | 'name' | 'disabled' | 'label' | 'itemProps'
> &
    Pick<DealershipPriceDisclaimerDrawerProps, 'dealers'> &
    Pick<TranslationDrawerProps, 'languages'> & {
        isEdit?: boolean;
        isMultipleEntry?: boolean;
        tooltip?: FormItemProps['tooltip'];
        disclaimerKind?: DisclaimerKind;
    };

const DealershipPriceDisclaimerField = ({
    name,
    dealers,
    disclaimerKind = 'priceDisclaimer',
    disabled,
    languages,
    options,
    isEdit,
    isMultipleEntry,
    ...props
}: DealershipPriceDisclaimerFieldProps) => {
    const drawer = useDealershipPriceDisclaimerDrawer();
    const multiplEntryDrawer = useDealershipPriceDisclaimerMultipleEntryDrawer();
    const translatedDrawer = useTranslationDrawer();
    const translatedMultipleEntryDrawer = useTranslationMultipleEntryDrawer();

    // hide button completely when disable
    const button = disabled ? null : (
        <Button
            icon={<ShopOutlined style={{ color: 'var(--ant-primary-color)' }} />}
            onClick={isMultipleEntry ? multiplEntryDrawer.open : drawer.open}
            size="small"
            type="text"
        />
    );

    return (
        <>
            <Col onClick={drawer.open}>
                <FormFields.InputField
                    name={
                        isMultipleEntry ? `${name}.defaultValue[0].defaultValue` : `${name}.defaultValue.defaultValue`
                    }
                    {...props}
                    addonAfter={button}
                    onClick={drawer.open}
                    style={{ width: '100%' }}
                    disabled
                />
            </Col>
            {!isMultipleEntry && drawer.render({ name, title: props.label, dealers, options })}
            {isMultipleEntry &&
                multiplEntryDrawer.render({ name, title: props.label, dealers, disclaimerKind, options, isEdit })}
            {!isMultipleEntry && translatedDrawer.render({ name: name, title: props.label, languages })}
            {isMultipleEntry && translatedMultipleEntryDrawer.render({ name: name, title: props.label, languages })}
        </>
    );
};

export default DealershipPriceDisclaimerField;
